import * as React from 'react';
import { Container, Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { loadReviewWrite } from '../../ReviewsContext/actions.js';
import { useReviewsContext } from '../../ReviewsContext/ReviewsContext.js';

const REVIEW_WRITE_ID = 'pr-review-write';
const ReviewWrite = ({ selfUrl  })=>{
    const { getLabel  } = useIntl();
    const { enabled , dispatch  } = useReviewsContext();
    const [submitted, setSubmitted] = React.useState(false);
    const onSubmit = React.useCallback(()=>{
        setSubmitted(true);
        window && window.scrollTo(0, 0);
    }, []);
    React.useEffect(()=>{
        if (enabled) {
            dispatch(loadReviewWrite({
                id: REVIEW_WRITE_ID,
                returnUrl: selfUrl,
                onSubmit
            }));
        }
    }, [
        enabled,
        selfUrl,
        onSubmit
    ]);
    if (!enabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "review-write",
        "data-t": "review-write"
    }, /*#__PURE__*/ React.createElement(Container, null, !submitted && /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, getLabel('reviews.write.title')), /*#__PURE__*/ React.createElement("div", {
        id: REVIEW_WRITE_ID
    })));
};

export { REVIEW_WRITE_ID, ReviewWrite as default };
//# sourceMappingURL=ReviewWrite.js.map
